import {
  getChoiceResultsRequest,
  getChoiceResultsResponse,
} from '@core-api/presentation/presentation/questions/{admin_key}/choice-results';
import { getFetchResultsCacheKey } from '@mentimeter/core-hooks';
import { useFetchResultsBase } from './use-fetch-results-base';

interface UseFetchChoiceResultsParams {
  adminKey: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
  segmentBy?: string | undefined;
}

export const useFetchChoiceResults = ({
  adminKey,
  shouldFetchResults,
  sessionId,
}: UseFetchChoiceResultsParams) => {
  const requestParams = { adminKey };
  const cacheKey = adminKey
    ? getFetchResultsCacheKey(adminKey, sessionId)
    : null;

  return useFetchResultsBase({
    requestParams,
    cacheKey,
    shouldFetchResults,
    sessionId,
    getRequest: getChoiceResultsRequest,
    getResponse: getChoiceResultsResponse,
  });
};
